











import {Component, Provide, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class HomeFooter extends Vue {

    @Provide()
    public date = new Date();

}
